<template>
    <div>

        <navbar></navbar>

        <div class="bg-header-round-small">
            <div class="container">
                <h1>Impressum</h1>
            </div>
        </div>

        <section class="container">
            <div class="flex mb-4 flex-wrap">
                <div class="w-1/2 sm:w-full">
                    <p>
                        <b>Firma: </b>
                        <br>Couch Gourmet GmbH
                        <br> Maxhofstr. 34
                        <br>81475 München
                        <br>info@couch-gourmet.com

                        <br>Umsatzsteuer-Identifikationsnummer:   DE316394595
                        <br>Steuernummer: 143/126/81286
                        <br>Amtsgericht München HRA 99388
                        <br>Geschäftsführender Gesellschafter:
                        <br>Sparber, Andreas Anton, München
                    </p>
                </div>
                <div class="w-1/2 sm:w-full">
                    <p>
                        <b>Gestaltung, Konzeption & Umsetzung: </b>
                        <br>2W Media GmbH
                        <br>Martin-Kollar-Str. 5
                        <br>81829 München
                        <br>
                        <br>
                        <br>
                        <b>Beschwerdeverfahren / Streitschlichtung </b>
                        <br>
                        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <a href="http://ec.europa.eu/consumers/odr/" >http://ec.europa.eu/consumers/odr/</a> finden. Verbraucher haben die Möglichkeit, diese Plattform für die Beilegung ihrer Streitigkeiten zu nutzen. Wir sind grundsätzlich bereit, an einem außergerichtlichen Schlichtungsverfahren teilzunehmen
                    </p>
                </div>

            </div>
        </section>

        <cgfooter></cgfooter>

    </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import CgFooter from '@/components/CgFooter.vue'

  export default {
    name: 'serviceImprint',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/service/Imprint.vue